import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px ${theme.spacing.space100}px `,
    marginTop: 70,
    display: "grid",
    gap: theme.spacing.space8,
  },
  noti: {
    background: theme.colors.Background3,
  },
  btn: {
    marginTop: theme.spacing.space20,
  },
  page: {
    background: theme.colors.Background1,
    color: theme.colors.TextDefault,
    overflow: "scroll",
    fontFamily: "Poppins",
  },

  empty: {
    color: theme.colors.TextSilver,
    padding: theme.spacing.space24,
    textAlign: "center",
  },
  buttonGroup: {
    display: "grid",
    gap: theme.spacing.space12,
    position: "fixed",
    bottom: "15px",
    padding: "15px",
    width: "92%",
  },
  groupHeading: {
    fontSize: 12,
    letterSpacing: 0.2,
    color: theme.colors.TextGray,
  },
  group: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space12,
  },
}));
